module.exports = __webpack_public_path__ + "static/icons/icon-heart-outline-18cbd864a7c74cd285b87b45478b7845.svg";